import ConversationResponseShape from 'owa-service/lib/contract/ConversationResponseShape';
import conversationResponseShape from 'owa-service/lib/factory/conversationResponseShape';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

const FindConversationShapeName: string = 'ReactConversationListView';
const FindConversationSentItemsShapeName: string = 'ReactConversationSentItemsListView';

/**
 * Gets find conversation response shape.
 * @returns The ConversationResponseShape
 */
export function getFindConversationResponseShape(): ConversationResponseShape {
    return conversationResponseShape({ BaseShape: 'IdOnly' });
}

/**
 * Gets find conversation shape name based on the folder. The ReactConversationSentItemsListView
 * shape gives back recipients whereas the ReactConversationListView gives back senders.
 * @param folderId the folder for which we are going to do findConversation
 * @returns the shape name
 */
export function getFindConversationShape(folderId: string): string {
    return folderIdToName(folderId) === 'sentitems' || folderIdToName(folderId) === 'drafts'
        ? FindConversationSentItemsShapeName
        : FindConversationShapeName;
}
